const countryData = {
  "Antioquia": {
    "Medellín": "05001",
    "Abejorral": "05002",
    "Alejandría": "05021",
    "Amagá": "05030",
    "Amalfi": "05031",
    "Andes": "05034",
    "Angelópolis": "05036",
    "Angostura": "05038",
    "Anorí": "05040",
    "Santa Fé De Antioquia": "05042",
    "Anzá": "05044",
    "Apartadó": "05045",
    "Arboletes": "05051",
    "Argelia": "05055",
    "Armenia": "05059",
    "Barbosa": "05079",
    "Belmira": "05086",
    "Bello": "05088",
    "Betania": "05091",
    "Betulia": "05093",
    "Ciudad Bolívar": "05101",
    "Buriticá": "05113",
    "Cáceres": "05120",
    "Caicedo": "05125",
    "Caldas": "05129",
    "Campamento": "05134",
    "Cañasgordas": "05138",
    "Caramanta": "05145",
    "Carepa": "05147",
    "El Carmen De Viboral": "05148",
    "Carolina": "05150",
    "Caucasia": "05154",
    "Chigorodó": "05172",
    "Cisneros": "05190",
    "Cocorná": "05197",
    "Concordia": "05209",
    "Copacabana": "05212",
    "Dabeiba": "05234",
    "Donmatías": "05237",
    "El Bagre": "05250",
    "Entrerríos": "05264",
    "Envigado": "05266",
    "Fredonia": "05282",
    "Frontino": "05284",
    "Giraldo": "05306",
    "Girardota": "05308",
    "Gómez Plata": "05310",
    "Granada": "05313",
    "Guarne": "05318",
    "Guatapé": "05321",
    "Heliconia": "05347",
    "Itagüí": "05360",
    "Ituango": "05361",
    "Jardín": "05364",
    "Jericó": "05368",
    "La Ceja": "05376",
    "La Estrella": "05380",
    "La Pintada": "05390",
    "La Unión": "05400",
    "Liborina": "05411",
    "Maceo": "05425",
    "Marinilla": "05440",
    "Montebello": "05467",
    "Mutatá": "05480",
    "Nariño": "05483",
    "Necoclí": "05490",
    "Nechí": "05495",
    "Olaya": "05501",
    "Peñol": "05541",
    "Peque": "05543",
    "Pueblorrico": "05576",
    "Puerto Berrío": "05579",
    "Puerto Nare": "05585",
    "Puerto Triunfo": "05591",
    "Remedios": "05604",
    "Retiro": "05607",
    "Rionegro": "05615",
    "Sabanalarga": "05628",
    "Sabaneta": "05631",
    "Salgar": "05642",
    "San Andrés De Cuerquía": "05647",
    "San Carlos": "05649",
    "San Francisco": "05652",
    "San Jerónimo": "05656",
    "San José De La Montaña": "05658",
    "San Juan De Urabá": "05659",
    "San Luis": "05660",
    "San Pedro De Los Milagros": "05664",
    "San Pedro De Urabá": "05665",
    "San Rafael": "05667",
    "San Roque": "05670",
    "San Vicente Ferrer": "05674",
    "Santa Bárbara": "05679",
    "Santa Rosa De Osos": "05686",
    "Santo Domingo": "05690",
    "El Santuario": "05697",
    "Segovia": "05736",
    "Sonsón": "05756",
    "Sopetrán": "05761",
    "Támesis": "05789",
    "Tarazá": "05790",
    "Toledo": "05819",
    "Turbo": "05837",
    "Uramita": "05842",
    "Urrao": "05847",
    "Valparaíso": "05856",
    "Vegachí": "05858",
    "Venecia": "05861",
    "Yalí": "05885",
    "Yarumal": "05887",
    "Yolombó": "05890",
    "Yondó": "05893",
    "Zaragoza": "05895",
    "Bajira - Mutata": "05480"
  },
  "Atlántico": {
    "Barranquilla": "08001",
    "Baranoa": "08078",
    "Campo De La Cruz": "08137",
    "Candelaria": "08141",
    "Galapa": "08296",
    "Juan De Acosta": "08372",
    "Luruaco": "08421",
    "Malambo": "08433",
    "Manati": "08436",
    "Palmar De Varela": "08520",
    "Polonuevo": "08558",
    "Ponedera": "08560",
    "Puerto Colombia": "08573",
    "Repelon": "08606",
    "Sabanagrande": "08634",
    "Sabanalarga": "08638",
    "Santa Lucia": "08675",
    "Santo Tomas": "08685",
    "Soledad": "08758",
    "Suan": "08770",
    "Usiacuri": "08849"
  },
  "Bogotá, D.C.": {
    "Bogotá, D.c.": "11001"
  },
  "Bolivar": {
    "Cartagena": "13001",
    "Achi": "13006",
    "Arenal": "13042",
    "Arjona": "13052",
    "Barranco De Loba": "13074",
    "Calamar": "13140",
    "Cantagallo": "13160",
    "Cicuco": "13188",
    "Clemencia": "13222",
    "El Carmen De Bolivar": "13244",
    "Hatillo De Loba": "13300",
    "Magangue": "13430",
    "Maria La Baja": "13442",
    "Santa Cruz De Mompox": "13468",
    "Morales": "13473",
    "Regidor": "13580",
    "Rio Viejo": "13600",
    "San Estanislao": "13647",
    "San Jacinto": "13654",
    "San Juan Nepomuceno": "13657",
    "San Martin De Loba": "13667",
    "San Pablo": "13670",
    "Santa Rosa": "13683",
    "Santa Rosa Del Sur": "13688",
    "Simiti": "13744",
    "Talaigua Nuevo": "13780",
    "Turbaco": "13836",
    "Turbana": "13838",
    "Villanueva": "13873",
    "Monte Cristo": "13458",
    "San Cristobal": "13620",
    "Tiquisio": "13810",
    "Tiquisio Nuevo": "13811"
  },
  "Boyaca": {
    "Tunja": "15001",
    "Aquitania": "15047",
    "Arcabuco": "15051",
    "Belen": "15087",
    "Berbeo": "15090",
    "Beteitiva": "15092",
    "Boavita": "15097",
    "Buenavista": "15109",
    "Campohermoso": "15135",
    "Cerinza": "15162",
    "Chinavita": "15172",
    "Chiquinquira": "15176",
    "Chiscas": "15180",
    "Chita": "15183",
    "Chitaraque": "15185",
    "Chivata": "15187",
    "Cienega": "15189",
    "Combita": "15204",
    "Coper": "15212",
    "Covarachia": "15218",
    "Cubara": "15223",
    "Cucaita": "15224",
    "Cuitiva": "15226",
    "Duitama": "15238",
    "El Cocuy": "15244",
    "El Espino": "15248",
    "Firavitoba": "15272",
    "Floresta": "15276",
    "Gameza": "15296",
    "Garagoa": "15299",
    "Guacamayas": "15317",
    "Guateque": "15322",
    "Guayata": "15325",
    "Güican De La Sierra": "15332",
    "Iza": "15362",
    "Jenesano": "15367",
    "Labranzagrande": "15377",
    "La Capilla": "15380",
    "La Uvita": "15403",
    "Villa De Leyva": "15407",
    "Macanal": "15425",
    "Maripi": "15442",
    "Miraflores": "15455",
    "Mongua": "15464",
    "Mongui": "15466",
    "Moniquira": "15469",
    "Motavita": "15476",
    "Muzo": "15480",
    "Nobsa": "15491",
    "Nuevo Colon": "15494",
    "Oicata": "15500",
    "Otanche": "15507",
    "Pachavita": "15511",
    "Paez": "15514",
    "Paipa": "15516",
    "Pajarito": "15518",
    "Panqueba": "15522",
    "Pauna": "15531",
    "Paz De Rio": "15537",
    "Pesca": "15542",
    "Puerto Boyaca": "15572",
    "Quipama": "15580",
    "Ramiriqui": "15599",
    "Raquira": "15600",
    "Rondon": "15621",
    "Saboya": "15632",
    "Sachica": "15638",
    "Samaca": "15646",
    "San Eduardo": "15660",
    "San Jose De Pare": "15664",
    "San Luis De Gaceno": "15667",
    "San Mateo": "15673",
    "San Pablo De Borbur": "15681",
    "Santa Maria": "15690",
    "Santa Rosa De Viterbo": "15693",
    "Santa Sofia": "15696",
    "Sativanorte": "15720",
    "Sativasur": "15723",
    "Siachoque": "15740",
    "Soata": "15753",
    "Socota": "15755",
    "Socha": "15757",
    "Sogamoso": "15759",
    "Somondoco": "15761",
    "Sora": "15762",
    "Sotaquira": "15763",
    "Soraca": "15764",
    "Susacon": "15774",
    "Sutamarchan": "15776",
    "Sutatenza": "15778",
    "Tasco": "15790",
    "Tenza": "15798",
    "Tibana": "15804",
    "Tibasosa": "15806",
    "Tinjaca": "15808",
    "Tipacoque": "15810",
    "Toca": "15814",
    "Topaga": "15820",
    "Tunungua": "15832",
    "Turmeque": "15835",
    "Tuta": "15837",
    "Umbita": "15842",
    "Ventaquemada": "15861",
    "Viracacha": "15879",
    "Zetaquira": "15897"
  },
  "Caldas": {
    "Manizales": "17001",
    "Aguadas": "17013",
    "Anserma": "17042",
    "Aranzazu": "17050",
    "Belalcazar": "17088",
    "Chinchina": "17174",
    "Filadelfia": "17272",
    "La Dorada": "17380",
    "La Merced": "17388",
    "Manzanares": "17433",
    "Marmato": "17442",
    "Marquetalia": "17444",
    "Marulanda": "17446",
    "Neira": "17486",
    "Norcasia": "17495",
    "Pacora": "17513",
    "Palestina": "17524",
    "Pensilvania": "17541",
    "Riosucio": "17614",
    "Risaralda": "17616",
    "Salamina": "17653",
    "Samana": "17662",
    "Supia": "17777",
    "Victoria": "17867",
    "Villamaria": "17873",
    "Viterbo": "17877"
  },
  "Caqueta": {
    "Florencia": "18001",
    "Albania": "18029",
    "Cartagena Del Chaira": "18150",
    "Curillo": "18205",
    "El Doncello": "18247",
    "El Paujil": "18256",
    "La Montañita": "18410",
    "Milan": "18460",
    "Morelia": "18479",
    "Puerto Rico": "18592",
    "San Jose Del Fragua": "18610",
    "San Vicente Del Caguan": "18753",
    "Valparaiso": "18860"
  },
  "Cauca": {
    "Popayan": "19001",
    "Argelia": "19050",
    "Balboa": "19075",
    "Bolivar": "19100",
    "Cajibio": "19130",
    "Caldono": "19137",
    "Caloto": "19142",
    "Corinto": "19212",
    "El Tambo": "19256",
    "Florencia": "19290",
    "Guapi": "19318",
    "Inza": "19355",
    "Mercaderes": "19450",
    "Miranda": "19455",
    "Morales": "19473",
    "Padilla": "19513",
    "Patia": "19532",
    "Piamonte": "19533",
    "Piendamo - Tunia": "19548",
    "Puerto Tejada": "19573",
    "Rosas": "19622",
    "Santander De Quilichao": "19698",
    "Silvia": "19743",
    "Suarez": "19780",
    "Sucre": "19785",
    "Timbio": "19807",
    "Timbiqui": "19809",
    "Toribio": "19821",
    "Totoro": "19824",
    "Villa Rica": "19845",
    "El Plateado": "19050"
  },
  "Cesar": {
    "Valledupar": "20001",
    "Aguachica": "20011",
    "Agustin Codazzi": "20013",
    "Astrea": "20032",
    "Becerril": "20045",
    "Bosconia": "20060",
    "Chimichagua": "20175",
    "Chiriguana": "20178",
    "Curumani": "20228",
    "El Copey": "20238",
    "El Paso": "20250",
    "Gamarra": "20295",
    "La Gloria": "20383",
    "La Jagua De Ibirico": "20400",
    "Pailitas": "20517",
    "Pelaya": "20550",
    "Pueblo Bello": "20570",
    "Rio De Oro": "20614",
    "La Paz": "20621",
    "San Alberto": "20710",
    "San Diego": "20750",
    "San Martin": "20770",
    "Tamalameque": "20787"
  },
  "Cordoba": {
    "Monteria": "23001",
    "Ayapel": "23068",
    "Buenavista": "23079",
    "Cerete": "23162",
    "Chinu": "23182",
    "Cienaga De Oro": "23189",
    "Cotorra": "23300",
    "La Apartada": "23350",
    "Lorica": "23417",
    "Montelibano": "23466",
    "Planeta Rica": "23555",
    "Pueblo Nuevo": "23570",
    "Puerto Escondido": "23574",
    "Puerto Libertador": "23580",
    "Purisima De La Concepcion": "23586",
    "Sahagun": "23660",
    "San Antero": "23672",
    "San Bernardo Del Viento": "23675",
    "San Pelayo": "23686",
    "Valencia": "23855"
  },
  "Cundinamarca": {
    "Agua De Dios": "25001",
    "Alban": "25019",
    "Anapoima": "25035",
    "Anolaima": "25040",
    "Arbelaez": "25053",
    "Bituima": "25095",
    "Bojaca": "25099",
    "Cabrera": "25120",
    "Cachipay": "25123",
    "Cajica": "25126",
    "Caparrapi": "25148",
    "Caqueza": "25151",
    "Carmen De Carupa": "25154",
    "Chaguani": "25168",
    "Chia": "25175",
    "Chipaque": "25178",
    "Choachi": "25181",
    "Choconta": "25183",
    "Cogua": "25200",
    "Cota": "25214",
    "Cucunuba": "25224",
    "El Colegio": "25245",
    "El Peñon": "25258",
    "El Rosal": "25260",
    "Facatativa": "25269",
    "Fomeque": "25279",
    "Fosca": "25281",
    "Funza": "25286",
    "Fuquene": "25288",
    "Fusagasuga": "25290",
    "Gachala": "25293",
    "Gachancipa": "25295",
    "Gacheta": "25297",
    "Gama": "25299",
    "Girardot": "25307",
    "Granada": "25312",
    "Guacheta": "25317",
    "Guaduas": "25320",
    "Guasca": "25322",
    "Guatavita": "25326",
    "Guayabal De Siquima": "25328",
    "Guayabetal": "25335",
    "Gutierrez": "25339",
    "Jerusalen": "25368",
    "Junin": "25372",
    "La Calera": "25377",
    "La Mesa": "25386",
    "La Palma": "25394",
    "La Vega": "25402",
    "Lenguazaque": "25407",
    "Macheta": "25426",
    "Madrid": "25430",
    "Manta": "25436",
    "Medina": "25438",
    "Mosquera": "25473",
    "Nariño": "25483",
    "Nemocon": "25486",
    "Nilo": "25488",
    "Nocaima": "25491",
    "Venecia": "25506",
    "Pacho": "25513",
    "Paime": "25518",
    "Paratebueno": "25530",
    "Pasca": "25535",
    "Puerto Salgar": "25572",
    "Puli": "25580",
    "Quebradanegra": "25592",
    "Quetame": "25594",
    "Quipile": "25596",
    "Apulo": "25599",
    "Ricaurte": "25612",
    "San Antonio Del Tequendama": "25645",
    "San Bernardo": "25649",
    "San Juan De Rioseco": "25662",
    "Sasaima": "25718",
    "Sesquile": "25736",
    "Sibate": "25740",
    "Silvania": "25743",
    "Simijaca": "25745",
    "Soacha": "25754",
    "Sopo": "25758",
    "Subachoque": "25769",
    "Suesca": "25772",
    "Supata": "25777",
    "Susa": "25779",
    "Sutatausa": "25781",
    "Tabio": "25785",
    "Tausa": "25793",
    "Tena": "25797",
    "Tenjo": "25799",
    "Tibacuy": "25805",
    "Tibirita": "25807",
    "Tocaima": "25815",
    "Tocancipa": "25817",
    "Topaipi": "25823",
    "Ubala": "25839",
    "Ubaque": "25841",
    "Villa De San Diego De Ubate": "25843",
    "Une": "25845",
    "Utica": "25851",
    "Vergara": "25862",
    "Viani": "25867",
    "Villagomez": "25871",
    "Villapinzon": "25873",
    "Villeta": "25875",
    "Viota": "25878",
    "Yacopi": "25885",
    "Zipacon": "25898",
    "Zipaquira": "25899",
    "San Francisco": "25372"
  },
  "Choco": {
    "Quibdo": "27001",
    "Bahia Solano": "27075",
    "Certegui": "27160",
    "Condoto": "27205",
    "El Carmen De Atrato": "27245",
    "Istmina": "27361",
    "Lloro": "27413",
    "Novita": "27491",
    "Riosucio": "27615",
    "Tado": "27787"
  },
  "Huila": {
    "Neiva": "41001",
    "Acevedo": "41006",
    "Agrado": "41013",
    "Aipe": "41016",
    "Algeciras": "41020",
    "Altamira": "41026",
    "Baraya": "41078",
    "Campoalegre": "41132",
    "Colombia": "41206",
    "Garzon": "41298",
    "Gigante": "41306",
    "Guadalupe": "41319",
    "Hobo": "41349",
    "Iquira": "41357",
    "San Jose De Isnos": "41359",
    "La Argentina": "41378",
    "La Plata": "41396",
    "Nataga": "41483",
    "Oporapa": "41503",
    "Paicol": "41518",
    "Palermo": "41524",
    "Palestina": "41530",
    "Pital": "41548",
    "Pitalito": "41551",
    "Rivera": "41615",
    "San Agustin": "41668",
    "Santa Maria": "41676",
    "Suaza": "41770",
    "Tarqui": "41791",
    "Tesalia": "41797",
    "Tello": "41799",
    "Teruel": "41801",
    "Timana": "41807",
    "Villavieja": "41872",
    "Yaguara": "41885"
  },
  "La Guajira": {
    "Riohacha": "44001",
    "Albania": "44035",
    "Barrancas": "44078",
    "Dibulla": "44090",
    "Distracción": "44098",
    "El Molino": "44110",
    "Fonseca": "44279",
    "Hatonuevo": "44378",
    "Maicao": "44430",
    "Manaure": "44560",
    "San Juan Del Cesar": "44650",
    "Uribia": "44847",
    "Urumita": "44855",
    "Villanueva": "44874",
    "Buenavista": "44099"
  },
  "Magdalena": {
    "Santa Marta": "47001",
    "Aracataca": "47053",
    "Ariguani": "47058",
    "Chivolo": "47170",
    "Cienaga": "47189",
    "El Banco": "47245",
    "El Reten": "47268",
    "Fundacion": "47288",
    "Guamal": "47318",
    "Nueva Granada": "47460",
    "Pivijay": "47551",
    "Plato": "47555",
    "San Sebastian De Buenavista": "47692",
    "Santa Ana": "47707",
    "Tenerife": "47798",
    "San Angel": "47660",
    "Sevilla": "47980"
  },
  "Meta": {
    "Villavicencio": "50001",
    "Acacias": "50006",
    "Barranca De Upia": "50110",
    "Cabuyaro": "50124",
    "Castilla La Nueva": "50150",
    "Cubarral": "50223",
    "Cumaral": "50226",
    "El Castillo": "50251",
    "El Dorado": "50270",
    "Fuente De Oro": "50287",
    "Granada": "50313",
    "Guamal": "50318",
    "Mapiripan": "50325",
    "Mesetas": "50330",
    "La Macarena": "50350",
    "Uribe": "50370",
    "Lejanias": "50400",
    "Puerto Concordia": "50450",
    "Puerto Gaitan": "50568",
    "Puerto Lopez": "50573",
    "Puerto Rico": "50590",
    "Restrepo": "50606",
    "San Carlos De Guaroa": "50680",
    "San Juan De Arama": "50683",
    "San Juanito": "50686",
    "San Martin": "50689",
    "Vistahermosa": "50711"
  },
  "Nariño": {
    "Pasto": "52001",
    "Ancuya": "52036",
    "Barbacoas": "52079",
    "Belen": "52083",
    "Buesaco": "52110",
    "Consaca": "52207",
    "Contadero": "52210",
    "Cordoba": "52215",
    "Cuaspud Carlosama": "52224",
    "Cumbal": "52227",
    "Chachagüi": "52240",
    "El Rosario": "52256",
    "El Tablon De Gomez": "52258",
    "El Tambo": "52260",
    "Funes": "52287",
    "Guachucal": "52317",
    "Guaitarilla": "52320",
    "Gualmatan": "52323",
    "Iles": "52352",
    "Imues": "52354",
    "Ipiales": "52356",
    "La Cruz": "52378",
    "La Florida": "52381",
    "La Llanada": "52385",
    "La Union": "52399",
    "Linares": "52411",
    "Los Andes": "52418",
    "Nariño": "52480",
    "Policarpa": "52540",
    "Potosi": "52560",
    "Providencia": "52565",
    "Pupiales": "52585",
    "Ricaurte": "52612",
    "Samaniego": "52678",
    "Sandona": "52683",
    "San Bernardo": "52685",
    "San Lorenzo": "52687",
    "San Pablo": "52693",
    "San Pedro De Cartago": "52694",
    "Taminango": "52786",
    "Tangua": "52788",
    "Tumaco": "52835",
    "Tuquerres": "52838",
    "Yacuanquer": "52885",
    "Payan": "52427",
    "Ricaurte": "52427",
    "Bocas De Satinga": "52490",
    "Iscuande": "52696"
  },
  "Norte De Santander": {
    "San Jose De Cucuta": "54001",
    "Abrego": "54003",
    "Arboledas": "54051",
    "Bochalema": "54099",
    "Bucarasica": "54109",
    "Cacota": "54125",
    "Cachira": "54128",
    "Chinacota": "54172",
    "Chitaga": "54174",
    "Convencion": "54206",
    "Cucutilla": "54223",
    "El Carmen": "54245",
    "El Zulia": "54261",
    "La Esperanza": "54385",
    "Los Patios": "54405",
    "Mutiscua": "54480",
    "Ocaña": "54498",
    "Pamplona": "54518",
    "Pamplonita": "54520",
    "Puerto Santander": "54553",
    "Ragonvalia": "54599",
    "Salazar": "54660",
    "Sardinata": "54720",
    "Silos": "54743",
    "Tibu": "54810",
    "Toledo": "54820",
    "Villa Del Rosario": "54874"
  },
  "Quindio": {
    "Armenia": "63001",
    "Calarca": "63130",
    "Circasia": "63190",
    "Cordoba": "63212",
    "Filandia": "63272",
    "Genova": "63302",
    "La Tebaida": "63401",
    "Montenegro": "63470",
    "Quimbaya": "63594",
    "Salento": "63690"
  },
  "Risaralda": {
    "Pereira": "66001",
    "Apia": "66045",
    "Belen De Umbria": "66088",
    "Dosquebradas": "66170",
    "Guatica": "66318",
    "La Celia": "66383",
    "La Virginia": "66400",
    "Marsella": "66440",
    "Mistrato": "66456",
    "Pueblo Rico": "66572",
    "Quinchia": "66594",
    "Santa Rosa De Cabal": "66682",
    "Santuario": "66687"
  },
  "Santander": {
    "Bucaramanga": "68001",
    "Albania": "68020",
    "Aratoca": "68051",
    "Barbosa": "68077",
    "Barichara": "68079",
    "Barrancabermeja": "68081",
    "Betulia": "68092",
    "Bolivar": "68101",
    "California": "68132",
    "Capitanejo": "68147",
    "Carcasi": "68152",
    "Cerrito": "68162",
    "Charala": "68167",
    "Charta": "68169",
    "Chima": "68176",
    "Cimitarra": "68190",
    "Concepcion": "68207",
    "Confines": "68209",
    "Contratacion": "68211",
    "Coromoro": "68217",
    "Curiti": "68229",
    "El Carmen De Chucuri": "68235",
    "El Guacamayo": "68245",
    "El Peñon": "68250",
    "El Playon": "68255",
    "Enciso": "68266",
    "Florian": "68271",
    "Floridablanca": "68276",
    "Galan": "68296",
    "Gambita": "68298",
    "Giron": "68307",
    "Guaca": "68318",
    "Guadalupe": "68320",
    "Güepsa": "68327",
    "Jesus Maria": "68368",
    "La Belleza": "68377",
    "Landazuri": "68385",
    "La Paz": "68397",
    "Lebrija": "68406",
    "Los Santos": "68418",
    "Malaga": "68432",
    "Matanza": "68444",
    "Mogotes": "68464",
    "Molagavita": "68468",
    "Oiba": "68500",
    "Onzaga": "68502",
    "Piedecuesta": "68547",
    "Pinchote": "68549",
    "Puente Nacional": "68572",
    "Puerto Parra": "68573",
    "Puerto Wilches": "68575",
    "Rionegro": "68615",
    "Sabana De Torres": "68655",
    "San Andres": "68669",
    "San Gil": "68679",
    "San Joaquin": "68682",
    "San Jose De Miranda": "68684",
    "San Vicente De Chucuri": "68689",
    "Santa Barbara": "68705",
    "Santa Helena Del Opon": "68720",
    "Simacota": "68745",
    "Socorro": "68755",
    "Suaita": "68770",
    "Sucre": "68773",
    "Surata": "68780",
    "Tona": "68820",
    "Valle De San Jose": "68855",
    "Velez": "68861",
    "Vetas": "68867",
    "Villanueva": "68872",
    "Zapatoca": "68895",
    "Macaravita": "68425"
  },
  "Sucre": {
    "Sincelejo": "70001",
    "Caimito": "70124",
    "Corozal": "70215",
    "Coveñas": "70221",
    "Galeras": "70235",
    "Guaranda": "70265",
    "La Union": "70400",
    "Majagual": "70429",
    "Morroa": "70473",
    "Ovejas": "70508",
    "Sampues": "70670",
    "San Marcos": "70708",
    "San Onofre": "70713",
    "San Pedro": "70717",
    "San Luis De Since": "70742",
    "Sucre": "70771",
    "Santiago De Tolu": "70820"
  },
  "Tolima": {
    "Ibague": "73001",
    "Alpujarra": "73024",
    "Alvarado": "73026",
    "Ambalema": "73030",
    "Anzoategui": "73043",
    "Armero": "73055",
    "Ataco": "73067",
    "Cajamarca": "73124",
    "Carmen De Apicala": "73148",
    "Casabianca": "73152",
    "Chaparral": "73168",
    "Coyaima": "73217",
    "Cunday": "73226",
    "Dolores": "73236",
    "Espinal": "73268",
    "Falan": "73270",
    "Flandes": "73275",
    "Fresno": "73283",
    "Guamo": "73319",
    "Herveo": "73347",
    "Honda": "73349",
    "Icononzo": "73352",
    "Lerida": "73408",
    "Libano": "73411",
    "Mariquita": "73443",
    "Melgar": "73449",
    "Murillo": "73461",
    "Natagaima": "73483",
    "Ortega": "73504",
    "Palocabildo": "73520",
    "Piedras": "73547",
    "Planadas": "73555",
    "Prado": "73563",
    "Purificacion": "73585",
    "Rioblanco": "73616",
    "Roncesvalles": "73622",
    "Rovira": "73624",
    "Saldaña": "73671",
    "San Antonio": "73675",
    "San Luis": "73678",
    "Santa Isabel": "73686",
    "Valle De San Juan": "73854",
    "Venadillo": "73861",
    "Villarrica": "73873",
    "Santiago Perez": "73067",
    "Herrera": "73616"
  },
  "Valle Del Cauca": {
    "Cali": "76001",
    "Alcala": "76020",
    "Andalucia": "76036",
    "Ansermanuevo": "76041",
    "Argelia": "76054",
    "Buenaventura": "76109",
    "Guadalajara De Buga": "76111",
    "Bugalagrande": "76113",
    "Caicedonia": "76122",
    "Calima": "76126",
    "Candelaria": "76130",
    "Cartago": "76147",
    "Dagua": "76233",
    "El Aguila": "76243",
    "El Cairo": "76246",
    "El Cerrito": "76248",
    "El Dovio": "76250",
    "Florida": "76275",
    "Ginebra": "76306",
    "Guacari": "76318",
    "Jamundi": "76364",
    "La Cumbre": "76377",
    "La Union": "76400",
    "La Victoria": "76403",
    "Obando": "76497",
    "Palmira": "76520",
    "Pradera": "76563",
    "Restrepo": "76606",
    "Riofrio": "76616",
    "Roldanillo": "76622",
    "Sevilla": "76736",
    "Trujillo": "76828",
    "Tulua": "76834",
    "Ulloa": "76845",
    "Versalles": "76863",
    "Yotoco": "76890",
    "Yumbo": "76892",
    "Zarzal": "76895"
  },
  "Arauca": {
    "Arauca": "81001",
    "Arauquita": "81065",
    "Cravo Norte": "81220",
    "Fortul": "81300",
    "Puerto Rondon": "81591",
    "Saravena": "81736",
    "Tame": "81794"
  },
  "Casanare": {
    "Yopal": "85001",
    "Aguazul": "85010",
    "Chameza": "85015",
    "Hato Corozal": "85125",
    "Monterrey": "85162",
    "Nunchia": "85225",
    "Orocue": "85230",
    "Paz De Ariporo": "85250",
    "Pore": "85263",
    "Sabanalarga": "85300",
    "Sacama": "85315",
    "San Luis De Palenque": "85325",
    "Tamara": "85400",
    "Tauramena": "85410",
    "Trinidad": "85430",
    "Villanueva": "85440",
    "Mani": "85139"
  },
  "Putumayo": {
    "Mocoa": "86001",
    "Orito": "86320",
    "Puerto Asis": "86568",
    "Puerto Caicedo": "86569",
    "Puerto Leguizamo": "86573",
    "Sibundoy": "86749",
    "San Miguel": "86757",
    "Valle Del Guamuez La Hormiga": "86865",
    "Villagarzon": "86885"
  },
  "San Andres, Providencia": {
    "San Andres": "88001"
  },
  "Amazonas": {
    "Leticia": "91001"
  },
  "Guainia": {
    "Inirida": "94001"
  },
  "Guaviare": {
    "San Jose Del Guaviare": "95001",
    "Calamar": "95015",
    "El Retorno": "95025",
    "Miraflores": "95200"
  },
  "Vaupes": {
    "Mitu": "97001"
  },
  "Vichada": {
    "Puerto Carreño": "99001",
    "La Primavera": "99524",
    "Santa Rosalia": "99624",
    "Cumaribo": "99773"
  }
}